import React from 'react';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { object, string, func, bool } from 'prop-types';
import { withHandlers } from 'recompose';
import withTooltip from './withTooltip';

const styles = (theme) => ({
  formControl: {
    // margin: theme.spacing.unit,
    minWidth: '100%',
    marginBottom: 0,
    marginTop: theme.spacing(1),
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
});

function DateComponent(props) {
  const {
    id,
    label,
    value = '',
    classes,
    onChange = () => {},
    readOnly = false,
    required = false,
    type,
    shrink = true,
    error,
  } = props;
  return (
    <TextField
      key={id}
      id={id}
      label={label}
      margin="normal"
      required={required}
      onChange={onChange}
      className={classes.formControl}
      value={value}
      fullWidth
      disabled={readOnly}
      inputProps={{
        readOnly,
      }}
      type={type}
      InputLabelProps={{
        shrink: shrink,
      }}
      error={typeof error !== 'undefined'}
      helperText={typeof error !== 'undefined' && (error || 'Required')}
    />
  );
}

DateComponent.propTypes = {
  classes: object.isRequired,
  id: string.isRequired,
  label: string,
  value: string,
  onChange: func.isRequired,
  readOnly: bool,
  required: bool,
  tooltip: string,
  type: string,
  shrink: bool,
  error: string,
};

DateComponent.defaultProps = {
  value: '',
  readOnly: false,
  required: false,
  tooltip: '',
  label: '',
  type: 'date',
};

const SelectWithTooltip = withTooltip(DateComponent);
const enhance = withHandlers({
  onChange: (props) => (event) => {
    props.onChange(event.target.value);
  },
});

export default withStyles(styles)(enhance(SelectWithTooltip));



// WEBPACK FOOTER //
// ./src/view/forms/components/FormDatePicker.js